module.exports = __webpack_public_path__ + "img/pic31.0ab2085c.png";